var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"download-link-column"},on:{"click":function($event){_vm.linkClicked()}}},[_c('icon',{attrs:{"size":18,"icon-type":"slice"}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.linkData.text))])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35ac0daf","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/IntentEngine/_components/_tableColumn/TestRecordListTableDownloadLink.vue
// module id = null
// module chunks = 